import request from "project-config/services/request/request";
import { IUserProperty } from "@/utils/userinfo/types";

export const UserPropertyAPI = Object.freeze({
  getUserProperty: () => {
    return request.post<IUserProperty>(
      "/api/rendering/user/checkParticipatedActivities"
    );
  },
});
